import { render, staticRenderFns } from "./NameBar.vue?vue&type=template&id=34349d19&scoped=true&"
import script from "./NameBar.vue?vue&type=script&lang=js&"
export * from "./NameBar.vue?vue&type=script&lang=js&"
import style0 from "./NameBar.vue?vue&type=style&index=0&id=34349d19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34349d19",
  null
  
)

export default component.exports